export default "__VITE_ASSET__BYEKkmf___"